import {
  commonFacebookEventsUtil,
  wasFacebookEventRecentlyFired,
} from '@/shared/features/analytics/utils/facebookCommonAttributes';

export interface FacebookFindLocationSelectedStore {
  id: string | number;
  name: string;
  city: string;
}

export interface FacebookFindLocationParams {
  selectedStores?: FacebookFindLocationSelectedStore[];
  /** City-only payload (city catalog page has no selected store). */
  storeCity?: string;
  intentSource?: string;
}

function uniqueJoin(values: string[]): string {
  return [...new Set(values.map((value) => value.trim()).filter(Boolean))].join(', ');
}

export function facebookFindLocation({
  selectedStores,
  storeCity,
  intentSource,
}: FacebookFindLocationParams): void {
  const selected = (selectedStores ?? []).filter((store) => String(store.id ?? '').trim() !== '');
  const first = selected[0];
  const cityOnly = storeCity?.trim() ?? '';

  const locationKey = typeof window !== 'undefined' ? window.location.pathname : '';
  const selectionKey =
    selected.length > 0
      ? selected.map((store) => String(store.id)).join(',')
      : cityOnly
        ? `city:${cityOnly}`
        : 'empty';
  if (wasFacebookEventRecentlyFired(`FindLocation:${locationKey}:${selectionKey}`)) {
    return;
  }

  const attributes: Record<string, unknown> = {
    content_names: [],
    content_category: '',
  };

  if (selected.length > 0) {
    attributes.store_count = selected.length;
    attributes.store_ids = selected.map((store) => String(store.id));
    attributes.store_names = selected.map((store) => store.name.trim()).filter(Boolean);
    attributes.store_city = uniqueJoin(selected.map((store) => store.city));
    attributes.city = first.city;
  } else if (cityOnly) {
    attributes.store_city = cityOnly;
  }

  if (intentSource) {
    attributes.intent_source = intentSource;
  }

  commonFacebookEventsUtil('FindLocation', attributes);
}
